// extracted by mini-css-extract-plugin
module.exports = {"score":"_c517ca0","team":"_0666365","name":"_bd50e19"};